import { Box, SegmentedToggle, Tabs, Text } from "@wix/design-system";
import { useCallback, type FC, useState } from "react";
import { SitesList } from "../SitesList/SitesList";
import { useTranslation } from "@wix/fe-essentials-standalone";
import { useQuickStart } from "./useQuickStart";
import "./QuickStart.css";
import { ErrorBoundary } from "../Common/ErrorBoundry";
import { useMobile } from "../../../hooks/useMobile";

export const QuickStart: FC = () => {
  const { activeTab, handleToggleChange } = useQuickStart();
  const { t } = useTranslation();
  const isMobile = useMobile();

  if (isMobile) {
    return (
      <Box
        padding="0"
        width="100%"
        align="center"
        paddingTop="24px"
        marginTop="32px"
        direction="vertical"
        gap={2}
        backgroundColor="var(--wds-color-fill-surface-sunken)"
        borderTopLeftRadius="32px"
        borderTopRightRadius="32px"
      >
        {/* <Tabs
          size="small"
          minWidth="calc(100vw - 32px)"
          width="100%"
          alignment="center"
          type="uniformFull"
          items={[
            { id: "projects", title: "Recent Projects" },
            { id: "templates", title: "Templates" },
          ]}
          activeId={activeTab}
          onClick={(value) =>
            handleToggleChange(undefined!, value.id as string)
          }
        /> */}
        {activeTab === "projects" && (
          <ErrorBoundary>
            <SitesList />
          </ErrorBoundary>
        )}
        {/* TODO: Add templates */}
        {activeTab === "templates" && (
          <Box marginTop={4}>
            <Box direction="horizontal" gap={2} flexWrap="wrap">
              <Text size="medium" weight="bold">
                {t("landing.sites.templates")}
              </Text>
            </Box>
          </Box>
        )}
      </Box>
    );
  }

  return (
    <Box
      className="quick-start"
      width="100%"
      height="100%"
      align="left"
      gap={2}
      marginTop="10vh"
      marginBottom="0"
      direction="vertical"
      backgroundColor="var(--wds-color-fill-surface-sunken)"
      borderTopLeftRadius="32px"
      borderTopRightRadius="32px"
    >
      {/* <Box
        className="quick-start-toggle"
        backgroundColor="var(--Color-Fill-Surface-surface-default, #FFF)"
        boxShadow="0px 10px 18px 0px rgba(8, 20, 74, 0.08)"
        padding={1}
        borderRadius="12px"
        width={isMobile ? "100%" : "286px"}
        maxWidth="100%"
        direction="vertical"
      >
        <SegmentedToggle
          size="small"
          defaultSelected="projects"
          onClick={handleToggleChange}
        >
          <SegmentedToggle.Button value="projects">
            {t("landing.sites.recent_projects")}
          </SegmentedToggle.Button>
          <SegmentedToggle.Button value="templates">
            {t("landing.sites.templates")}
          </SegmentedToggle.Button>
        </SegmentedToggle>
      </Box> */}
      {activeTab === "projects" && (
        <ErrorBoundary>
          <SitesList />
        </ErrorBoundary>
      )}
      {/* TODO: Add templates */}
      {activeTab === "templates" && (
        <Box marginTop={4}>
          <Box direction="horizontal" gap={2} flexWrap="wrap">
            <Text size="medium" weight="bold">
              {t("landing.sites.templates")}
            </Text>
          </Box>
        </Box>
      )}
    </Box>
  );
};
